<template>
    <div v-if="countries" class="grid grid-cols-4 gap-6">
        <div class="col-span-4 md:col-span-2">
            <div
                class="form-item select-single required"
                :class="{ 'has-error': countryError }"
            >
                <div class="flex">
                    <label>Country: </label>
                </div>
                <select
                    v-model="location.country"
                    name="country"
                    class="form-select single"
                    @change="location.state = ''"
                >
                    <option value="">-- Select Country --</option>
                    <option v-for="(option, index) in countries" :value="index">
                        {{ option.title }}
                    </option>
                </select>
                <div class="text-error" v-if="countryError">
                    {{ countryError }}
                </div>
            </div>
        </div>
        <div class="col-span-4 md:col-span-2">
            <div
                class="form-item select-single required"
                :class="{ 'has-error': stateError }"
            >
                <div class="flex">
                    <label>State: </label>
                </div>
                <select
                    v-model="location.state"
                    name="state"
                    class="form-select single"
                >
                    <option value="">-- Select State --</option>
                    <option v-for="(option, index) in states" :value="index">
                        {{ option }}
                    </option>
                </select>
                <div class="text-error" v-if="stateError">
                    {{ stateError }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        location: {
            country: "",
            state: "",
        },
    };
}
import { mapGetters } from "vuex";
import _findKey from "lodash/findKey";
export default {
    props: {
        country: {
            type: String,
            required: false,
            default: "",
        },
        state: {
            type: String,
            required: false,
            default: "",
        },
        countryError: {
            type: String,
            required: false,
            default: "",
        },
        stateError: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return initialState();
    },
    mounted() {
        return this.$store.dispatch("fetchLocations", []).then((res) => {
            this.location.country = this.country;
            this.location.state = this.state;
            if (this.location.country.length == 0) {
                //show the default country
                this.location.country = _findKey(this.countries, {
                    is_default: true,
                });
            }
        });
    },
    methods: {
        countrySelect() {},
    },
    computed: {
        ...mapGetters(["locations"]),
        countries() {
            return this.locations;
        },
        states() {
            if (
                this.locations &&
                this.location.country in this.locations &&
                "states" in this.locations[this.location.country]
            ) {
                return this.locations[this.location.country]["states"];
            } else {
                return [];
            }
        },
    },
};
</script>

<style></style>
